export const MULTIPART_PART_SIZE_BYTES = 5 * 1024 * 1024;
export const MULTIPART_MAX_RETRIES = 5;
export const MULTIPART_INITIAL_RETRY_DELAY_MS = 1000;

export const DOWNLOAD_SAS_MAX_RETRIES = 5;
export const DOWNLOAD_SAS_INITIAL_RETRY_DELAY_MS = 1000;

export const RETENTION_PERIOD_DAYS_MAX = 60;
export const RETENTION_PERIOD_MONTHS_MIN = 3;
export const RETENTION_PERIOD_MONTHS_MAX = 60;
export const RETENTION_PERIOD_YEARS_MIN = 6;
export const RETENTION_PERIOD_YEARS_MAX = 10;

export const RETENTION_PERIOD_MONTHS_COUNT = RETENTION_PERIOD_MONTHS_MAX - RETENTION_PERIOD_MONTHS_MIN + 1;
export const RETENTION_PERIOD_YEARS_COUNT = RETENTION_PERIOD_YEARS_MAX - RETENTION_PERIOD_YEARS_MIN + 1;

export const RETENTION_PERIOD_MONTHS_START_INDEX = RETENTION_PERIOD_DAYS_MAX + 1;
export const RETENTION_PERIOD_MONTHS_MAX_UI = 24;
export const RETENTION_PERIOD_COMBOBOX_MAX_INDEX = RETENTION_PERIOD_MONTHS_START_INDEX + (RETENTION_PERIOD_MONTHS_MAX_UI - RETENTION_PERIOD_MONTHS_MIN);
export const RETENTION_PERIOD_YEARS_START_INDEX = RETENTION_PERIOD_MONTHS_START_INDEX + RETENTION_PERIOD_MONTHS_COUNT;
export const RETENTION_PERIOD_SLIDER_MAX = RETENTION_PERIOD_YEARS_START_INDEX + RETENTION_PERIOD_YEARS_COUNT - 1;

export type KeepUnit = 'd' | 'm' | 'y';
